<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m10.6 16.6 7-7-1.4-1.4-5.6 5.6-2.8-2.9-1.5 1.4zM12 22a10 10 0 0 1-7-3A10 10 0 0 1 2.7 8.2 10 10 0 0 1 12 2a10 10 0 0 1 7 3 10 10 0 0 1 2.2 10.9A10 10 0 0 1 12 22"
    />
  </svg>
</template>
